import {
    LIST_SCAN_REQUEST,
    LIST_SCAN_SUCCESS,
    LIST_SCAN_FAILED,

    CRAWL_ADD,
    CRAWL_ADD_SUCCESS,
    CRAWL_ADD_FAILED

 } from "../actions/urlAuditActions";

 const initialState = {
    loading:false,
    scansList:[],
    error:null,
    // newCrawlResponse:{}
 }

 const urlAuditReducer =(state=initialState, action) => {
    switch (action.type) {
        case LIST_SCAN_REQUEST:
            return {
                ...state,
                loading:true,
                error:'',
            }
        case LIST_SCAN_SUCCESS:
            console.log("Getting data of scannned list",action.payload.scansList.data.data)
            return {
                ...state,
                loading:false,
                scansList:action.payload.scansList.data.data
                
            }
        
        case LIST_SCAN_FAILED:
             return{
                ...state,
                loading:false,
                scansList:[],
                error:action.payload
             }

        case CRAWL_ADD:
                 return{
                    ...state,
                    loading:true
             }
        case CRAWL_ADD_SUCCESS:
            return {
                ...state,
                error:null,
                newCrawlResponse: action.payload,
            }

        case CRAWL_ADD_FAILED: {
            return {
                ...state,
                loading:false,
                error:action.payload.error
            }
        }

        default:
            return state
            
    }
 }

 export default urlAuditReducer;